// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import { User, UserT, verifyUser } from "../archive/user";

/**
 * Response to a user create that minted an offline password.
 *
 * The password is PLAINTEXT and is returned exactly once, in the response to
 * the create that generated it. It is deliberately NOT a field of
 * `Archive.User`: that table is persisted, exported and re-imported, and a
 * credential must never travel in it.
 *
 * There is deliberately no read-side counterpart. The server stores an
 * argon2id hash, so a password can only ever be handed back by the call that
 * minted it; an `OfflinePassword` table carrying a `password_hash` used to sit
 * here and was removed, because a hash is not shareable with the person who
 * has to sign in and returning one only leaked grindable material.
 */
export class CreateUserResponse implements flatbuffers.IUnpackableObject<CreateUserResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): CreateUserResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsCreateUserResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: CreateUserResponse,
  ): CreateUserResponse {
    return (obj || new CreateUserResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsCreateUserResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: CreateUserResponse,
  ): CreateUserResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new CreateUserResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  user(obj?: User): User | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset
      ? (obj || new User()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!)
      : null;
  }

  /**
   * One-time plaintext offline password. EMPTY on a cloud server: that path
   * creates a directory identity and emails a temporary password instead,
   * so there is nothing for an operator to hand over.
   */
  userPassword(): string | null;
  userPassword(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  userPassword(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  static startCreateUserResponse(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addUser(builder: flatbuffers.Builder, userOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, userOffset, 0);
  }

  static addUserPassword(builder: flatbuffers.Builder, userPasswordOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, userPasswordOffset, 0);
  }

  static endCreateUserResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 4); // user
    return offset;
  }

  static createCreateUserResponse(
    builder: flatbuffers.Builder,
    userOffset: flatbuffers.Offset,
    userPasswordOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    CreateUserResponse.startCreateUserResponse(builder);
    CreateUserResponse.addUser(builder, userOffset);
    CreateUserResponse.addUserPassword(builder, userPasswordOffset);
    return CreateUserResponse.endCreateUserResponse(builder);
  }

  unpack(): CreateUserResponseT {
    return new CreateUserResponseT(
      this.user() !== null ? this.user()!.unpack() : null,
      this.userPassword(),
    );
  }

  unpackTo(_o: CreateUserResponseT): void {
    _o.user = this.user() !== null ? this.user()!.unpack() : null;
    _o.userPassword = this.userPassword();
  }

  unpackFields(...fields: string[]): CreateUserResponseT {
    const t = new CreateUserResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("user")) {
      t.user = this.user() !== null ? this.user()!.unpack() : null;
    }
    if (fieldSet.has("user_password")) {
      t.userPassword = this.userPassword();
    }
    return t;
  }
}

export class CreateUserResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public user: UserT | null = null,
    public userPassword: string | Uint8Array | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.user === null || this.user === undefined) {
      throw new Error('Required field "user" is not set');
    }
    const user = this.user !== null ? this.user!.pack(builder) : 0;
    const userPassword = this.userPassword !== null ? builder.createString(this.userPassword!) : 0;

    return CreateUserResponse.createCreateUserResponse(builder, user, userPassword);
  }

  clone(): CreateUserResponseT {
    const obj = new CreateUserResponseT();
    obj.user = this.user !== null ? this.user!.clone() : null;
    obj.userPassword = this.userPassword;
    return obj;
  }

  equals(other: CreateUserResponseT): boolean {
    if (this.user !== null && other.user !== null) {
      if (!this.user!.equals(other.user!)) return false;
    } else if (this.user !== other.user) return false;
    if (this.userPassword !== other.userPassword) return false;
    return true;
  }
}

export function verifyCreateUserResponse(verifier: flatbuffers.Verifier, tablePos: number): void {
  verifier.checkTable(tablePos);
  try {
    {
      const fieldPos = verifier.checkOffsetField(tablePos, 4);
      if (fieldPos !== 0) {
        const tableOffset = verifier.readInt32(fieldPos);
        verifyUser(verifier, fieldPos + tableOffset);
      }
    }
    verifier.checkRequiredField(tablePos, 4, "user");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
  } finally {
    verifier.popDepth();
  }
}
